var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "overlay",
          rawName: "v-overlay",
          value: {
            visible: _vm.isVisible,
            class: _vm.classes,
            handler: "hide",
          },
          expression: "{ visible: isVisible, class: classes, handler: 'hide' }",
        },
      ],
      ref: "modal-wrapper",
      class: [
        _vm.$style["mds-modal"],
        _vm.classObject,
        _vm.widthClass,
        _vm.sizeClass,
      ],
      attrs: { "data-mds-version": _vm.version, "aria-hidden": !_vm.isVisible },
    },
    [
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": _vm.$style["mds-modal-enter-active"],
            "leave-active-class": _vm.$style["mds-modal-leave-active"],
            "enter-class": _vm.$style["mds-modal-enter"],
            "leave-to-class": _vm.$style["mds-modal-leave-to"],
          },
        },
        [
          _c(
            "div",
            _vm._b(
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isVisible,
                    expression: "isVisible",
                  },
                ],
                class: _vm.$style["mds-modal__wrapper"],
                attrs: { role: "dialog", "aria-modal": "true" },
              },
              "div",
              _vm.$attrs,
              false
            ),
            [
              _c(
                "div",
                { class: _vm.$style["mds-modal__content"] },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }